<header
  class="sticky top-0 z-40 flex items-center gap-2 border-b border-slate-200 bg-white px-3 py-2 shadow-sm lg:hidden"
>
  <button
    type="button"
    class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-slate-700 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-500"
    (click)="toggleMobileMenu()"
    [attr.aria-expanded]="mobileMenuOpen"
    aria-controls="cms-sidebar"
    aria-label="Abrir menu"
  >
    <ng-icon name="heroBars3" size="22px"></ng-icon>
  </button>

  <a [routerLink]="['/']" class="flex min-w-0 flex-1 justify-center py-1" aria-label="ConectaOficina Admin">
    <img src="./assets/brand/logo_colorido.png" alt="ConectaOficina" class="h-8 w-auto max-w-[160px] object-contain" />
  </a>

  <span class="inline-flex h-11 w-11 shrink-0" aria-hidden="true"></span>
</header>

<div
  *ngIf="mobileMenuOpen"
  class="fixed inset-0 z-40 bg-slate-900/40 backdrop-blur-[1px] lg:hidden"
  (click)="closeMobileMenu()"
  aria-hidden="true"
></div>

<nav
  id="cms-sidebar"
  class="cms-sidebar-drawer fixed inset-y-0 left-0 z-50 flex w-[min(18rem,88vw)] flex-col overflow-y-auto bg-white px-5 py-4 shadow-xl transition-transform duration-300 ease-out lg:w-64 lg:!translate-x-0"
  [ngClass]="mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'"
  (click)="onDrawerClick($event)"
>
  <div class="mb-2 flex items-center justify-between lg:justify-center">
    <a [routerLink]="['/']" class="inline-flex justify-center py-2">
      <img src="./assets/brand/logo_colorido.png" alt="ConectaOficina" class="w-3/4 max-w-[180px]" />
    </a>
    <button
      type="button"
      class="inline-flex h-11 w-11 items-center justify-center rounded-lg text-slate-600 hover:bg-slate-100 lg:hidden"
      (click)="closeMobileMenu()"
      aria-label="Fechar menu"
    >
      <ng-icon name="heroXMark" size="22px"></ng-icon>
    </button>
  </div>

  <hr class="my-3 min-w-full border-slate-200" />

  <ul class="flex min-w-full flex-col list-none">
    <li class="items-center">
      <a
        [routerLink]="['/admin/dashboard']"
        class="flex items-end py-3 text-xs font-bold uppercase"
        routerLinkActive
        #adminDashboard="routerLinkActive"
        [ngClass]="
          adminDashboard.isActive
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
      >
        <ng-icon
          size="20px"
          name="heroHome"
          class="mr-2 text-sm"
          [ngClass]="adminDashboard.isActive ? 'opacity-75' : 'text-blueGray-300'"
        ></ng-icon>
        Dashboard
      </a>
    </li>

    <li class="items-center" *ngIf="showFinancialMenu">
      <a
        [routerLink]="['/admin/financial']"
        class="flex items-end py-3 text-xs font-bold uppercase"
        routerLinkActive
        #adminFinancial="routerLinkActive"
        [ngClass]="
          adminFinancial.isActive
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
      >
        <ng-icon
          size="20px"
          name="heroBanknotes"
          class="mr-2 text-sm"
          [ngClass]="adminFinancial.isActive ? 'opacity-75' : 'text-blueGray-300'"
        ></ng-icon>
        Financeiro
      </a>
    </li>

    <li class="items-center" *ngIf="showCompaniesMenu">
      <a
        [routerLink]="['/admin/companies']"
        class="flex items-end py-3 text-xs font-bold uppercase"
        routerLinkActive
        #adminEmpresas="routerLinkActive"
        [ngClass]="
          adminEmpresas.isActive
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
      >
        <ng-icon
          size="20px"
          name="heroBuildingOffice2"
          class="mr-2 text-sm"
          [ngClass]="adminEmpresas.isActive ? 'opacity-75' : 'text-blueGray-300'"
        ></ng-icon>
        Empresas
      </a>
    </li>

    <li class="items-center" *ngIf="showFuelStationsMenu">
      <a
        [routerLink]="['/admin/fuel-stations']"
        class="flex items-end py-3 text-xs font-bold uppercase"
        routerLinkActive
        #adminPostos="routerLinkActive"
        [ngClass]="
          adminPostos.isActive || isFuelStationsSectionActive()
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
      >
        <ng-icon
          size="20px"
          name="heroBolt"
          class="mr-2 text-sm"
          [ngClass]="adminPostos.isActive || isFuelStationsSectionActive() ? 'opacity-75' : 'text-blueGray-300'"
        ></ng-icon>
        Postos & Recarga
      </a>
    </li>

    <li class="relative items-center" #towTrucksMenuRoot *ngIf="showTowTrucksMenu">
      <button
        type="button"
        (click)="toggleTowTrucksMenu($event)"
        class="flex w-full items-center justify-between gap-2 rounded-md py-3 text-left text-xs font-bold uppercase focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-500"
        [ngClass]="
          isTowTrucksSectionActive()
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
        [attr.aria-expanded]="towTrucksMenuOpen"
        aria-haspopup="true"
      >
        <span class="flex items-end">
          <ng-icon
            size="20px"
            name="heroTruck"
            class="mr-2 text-sm"
            [ngClass]="isTowTrucksSectionActive() ? 'opacity-75' : 'text-blueGray-300'"
          ></ng-icon>
          Rebocadoras
        </span>
        <ng-icon
          name="heroChevronDown"
          size="18px"
          class="shrink-0 transition-transform duration-150"
          [ngClass]="towTrucksMenuOpen ? '-rotate-180' : ''"
        ></ng-icon>
      </button>
      <ul *ngIf="towTrucksMenuOpen" class="mb-2 ml-2 mt-1 space-y-0.5 border-l-2 border-brand-green-200 pl-4" role="menu">
        <li>
          <a
            routerLink="/admin/tow-trucks"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeTowTrucksMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Rebocadoras
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/tow-truck-calls"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeTowTrucksMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Chamadas de Reboque
          </a>
        </li>
      </ul>
    </li>

    <li class="relative items-center" #workshopsMenuRoot *ngIf="showWorkshopsMenu">
      <button
        type="button"
        (click)="toggleWorkshopsMenu($event)"
        class="flex w-full items-center justify-between gap-2 rounded-md py-3 text-left text-xs font-bold uppercase focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-500"
        [ngClass]="
          isWorkshopsSectionActive()
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
        [attr.aria-expanded]="workshopsMenuOpen"
        aria-haspopup="true"
      >
        <span class="flex items-end">
          <ng-icon
            size="20px"
            name="heroWrenchScrewdriver"
            class="mr-2 text-sm"
            [ngClass]="isWorkshopsSectionActive() ? 'opacity-75' : 'text-blueGray-300'"
          ></ng-icon>
          Oficinas & Serviços
        </span>
        <ng-icon
          name="heroChevronDown"
          size="18px"
          class="shrink-0 transition-transform duration-150"
          [ngClass]="workshopsMenuOpen ? '-rotate-180' : ''"
        ></ng-icon>
      </button>
      <ul *ngIf="workshopsMenuOpen" class="mb-2 ml-2 mt-1 space-y-0.5 border-l-2 border-brand-green-200 pl-4" role="menu">
        <li>
          <a
            routerLink="/admin/workshops"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeWorkshopsMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Oficinas
          </a>
        </li>
        <li *ngIf="auth.isSuperAdmin()">
          <a
            routerLink="/admin/workshop-leads"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeWorkshopsMenu()"
            class="flex items-center justify-between py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            <span>Pré-cadastros / Leads</span>
            <span class="rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold text-amber-800">Site</span>
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/customer-vehicles"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeWorkshopsMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Veículos de Clientes
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/appointments"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeWorkshopsMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Agendamentos
          </a>
        </li>
        <li>
          <a
            routerLink="/admin/quote-requests"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeWorkshopsMenu()"
            class="flex items-center justify-between py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            <span>Cotações (Leilão Reverso)</span>
            <span class="rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold text-amber-800">Ao Vivo</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>

  <hr class="my-3 min-w-full border-slate-200" />

  <ul class="mb-4 flex min-w-full flex-col list-none">
    <li class="items-center" *ngIf="showUsersMenu">
      <a
        [routerLink]="['/admin/users']"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: false }"
        #adminUsuarios="routerLinkActive"
        class="flex items-end py-3 text-xs font-bold uppercase"
        [ngClass]="
          adminUsuarios.isActive
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
      >
        <ng-icon
          size="20px"
          name="heroUser"
          class="mr-2 text-sm"
          [ngClass]="adminUsuarios.isActive ? 'opacity-75' : 'text-blueGray-300'"
        ></ng-icon>
        Usuários
      </a>
    </li>

    <li class="items-center" *ngIf="showAppUsersMenu">
      <a
        [routerLink]="['/admin/customers']"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: false }"
        #adminCustomers="routerLinkActive"
        class="flex items-end py-3 text-xs font-bold uppercase"
        [ngClass]="
          adminCustomers.isActive
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
      >
        <ng-icon
          size="20px"
          name="heroUsers"
          class="mr-2 text-sm"
          [ngClass]="adminCustomers.isActive ? 'opacity-75' : 'text-blueGray-300'"
        ></ng-icon>
        Clientes (App)
      </a>
    </li>

    <li class="relative items-center" #settingsMenuRoot *ngIf="showSettingsMenu">
      <button
        type="button"
        (click)="toggleSettingsMenu($event)"
        class="flex w-full items-center justify-between gap-2 rounded-md py-3 text-left text-xs font-bold uppercase focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-500"
        [ngClass]="
          isSettingsSectionActive()
            ? 'text-brand-green-600 hover:text-brand-green-700'
            : 'text-blueGray-700 hover:text-blueGray-500'
        "
        [attr.aria-expanded]="settingsMenuOpen"
        aria-haspopup="true"
      >
        <span class="flex items-end">
          <ng-icon
            size="20px"
            name="heroCog6Tooth"
            class="mr-2 text-sm"
            [ngClass]="isSettingsSectionActive() ? 'opacity-75' : 'text-blueGray-300'"
          ></ng-icon>
          Configurações
        </span>
        <ng-icon
          name="heroChevronDown"
          size="18px"
          class="shrink-0 transition-transform duration-150"
          [ngClass]="settingsMenuOpen ? '-rotate-180' : ''"
        ></ng-icon>
      </button>
      <ul *ngIf="settingsMenuOpen" class="mb-2 ml-2 mt-1 space-y-0.5 border-l-2 border-brand-green-200 pl-4" role="menu">
        <li *ngIf="auth.isSuperAdmin()">
          <a
            routerLink="/admin/service-catalog"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeSettingsMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Catálogo de Serviços
          </a>
        </li>
        <li *ngIf="auth.isSuperAdmin()">
          <a
            routerLink="/admin/payment-methods"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeSettingsMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Formas de Pagamento
          </a>
        </li>
        <li *ngIf="auth.isSuperAdmin() || auth.isFuelStationOwner()">
          <a
            routerLink="/admin/fuel-service-catalog"
            routerLinkActive="text-brand-green-600 font-bold"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="closeSettingsMenu()"
            class="block py-2 text-xs font-semibold uppercase text-blueGray-600 hover:text-brand-green-600"
            role="menuitem"
          >
            Catálogo (Combustível/Recarga)
          </a>
        </li>
      </ul>
    </li>

    <li class="items-center">
      <a
        (click)="logout()"
        class="flex cursor-pointer items-end py-3 text-xs font-bold uppercase text-red-400 hover:text-red-600"
      >
        <ng-icon size="20px" name="heroPower" class="mr-2 text-sm"></ng-icon>
        Sair
      </a>
    </li>
  </ul>
</nav>
